import { cn } from '~/shadcn/lib/utils'

type SummaryBlockProps = {
  label: string
  isMobile: boolean
  children: React.ReactNode
}

export function SummaryBlock({ label, isMobile, children }: SummaryBlockProps) {
  return (
    <div
      className={cn(
        'min-w-32 flex-0',
        isMobile ? 'flex-row items-center gap-1 py-3' : 'flex-col gap-1'
      )}>
      <span className="text-sm font-semibold text-muted text-nowrap">
        {label}
      </span>
      <div className="font-semibold">{children}</div>
    </div>
  )
}
